import '../lms/lms.scss'
import { Outlet } from 'react-router-dom'
import RenderOnRole from '../../components/RenderOnRole'
import { IPD_READ } from '../../utils/roles'
import './bms.scss'
const BedIpd = () => {
  return (
    <RenderOnRole
      roles={[IPD_READ]}
      element={
        <div className='lms-container total-full-height'>
          <div className='lms-content total-full-height'>
            <Outlet />
          </div>
        </div>
      }
    />
  )
}

export default BedIpd
